const metaAuth = {
    auth: [1]
}
const metaAuthTitle = {
    auth: [1],
    title: '提现'
}
const metaAuthAuthen = {
    auth: [1],
    title: '实名认证'
}

export default [
    {
        path: '/',
        name: 'index',
        redirect: '/home',
    },
    // 首页
    {
        path: '/',
        name: 'index',
        // meta: metaAuth,
        component: () => import('@/views/Home/index.vue'),
        children: [
            {
                name: 'home',
                path: '/home',
                meta: {
                    auth: [1],
                    // keepAlive: true,
                },
                component: () => import('@/views/Index/index.vue')
            },
            // 订单
            {
                /* path: '/Indent',
                name: 'Indent',
                meta: metaAuth,
                component: () => import('@/views/Home/index.vue'),
                children: [
                    { */
                path: '/order',
                name: 'order',
                meta: metaAuth,
                component: () => import('@/views/Order/index.vue'),
                /* }
            ] */
            },
            {
                path: '/my',
                name: 'my',
                meta: metaAuth,
                component: () => import('@/views/My/index.vue'),
            },
        ]
    },
    // 商品详情
    {
        name: 'particulars',
        path: '/particulars',
        meta: {
            auth: [1],
            // keepAlive: true,
        },
        component: () => import('@/views/Particulars/index.vue')
    },
    // 交易中心
    {
        path: "/tradingCenter",
        name: "tradingCenter",
        meta: {
            auth: [1],
        },
        component: () => import('@/views/Index/TradingCenter/index.vue'),
    },
    {
        name: 'gameServer',
        path: '/tradingCenter/gameServer',
        meta: {
            auth: [1],
        },
        component: () => import('@/views/Index/TradingCenter/GameServer/index.vue')
    },
    // 订单详情
    {
        path: "/orderDetail",
        name: "orderDetail",
        meta: {
            auth: [1],
        },
        component: () => import('@/views/Order/detail/index.vue'),
    },
    // 我的收藏
    {
        path: '/favorite',
        name: 'favorite',
        meta: metaAuth,
        component: () => import('@/views/My/favorite/index.vue'),
    },
    // 我的货架
    {
        path: '/shelves',
        name: 'shelves',
        meta: metaAuth,
        component: () => import('@/views/My/shelves/index.vue'),
    },
    // 提现
    {
        path: '/extract',
        name: 'extract',
        meta: metaAuthTitle,
        component: () => import('@/views/My/extract/index.vue'),
    },
    // 新提现 3.4.0后用这个
    {
        path: '/newExtract',
        name: 'newExtract',
        meta: metaAuthTitle,
        component: () => import('@/views/My/newExtract/index.vue'),
    },
    // 提现记录
    {
        path: '/extractRecord',
        name: 'extractRecord',
        meta: metaAuth,
        component: () => import('@/views/My/extract/components/record.vue'),
    },
    // 提现明细
    {
        path: '/extractDetail',
        name: 'extractDetail',
        meta: metaAuth,
        component: () => import('@/views/My/extract/components/detail.vue'),
    },
    // 实名认证
    {
        path: '/authentication',
        name: 'authentication',
        meta: metaAuthAuthen,
        component: () => import('@/views/My/authentication/index.vue'),
    },
    // 实名认证前验证短信
    {
        path: '/verificationCode',
        name: 'verificationCode',
        meta: metaAuthAuthen,
        component: () => import('@/views/My/authentication/verificationCode.vue'),
    },
    // 实名认证上传照片
    {
        path: '/authentication/upload',
        name: 'authenticationupload',
        meta: metaAuthAuthen,
        component: () => import('@/views/My/authentication/upload.vue'),
    },
    // 实名认证确认信息
    {
        path: '/authentication/confirm',
        name: 'authenticationconfirm',
        meta: metaAuthAuthen,
        component: () => import('@/views/My/authentication/confirm.vue'),
    },
    // 指定我
    {
        path: '/appoint',
        name: 'appoint',
        meta: metaAuth,
        component: () => import('@/views/My/appoint/index.vue'),
    },
    // 我要买
    {
        path: '/mywantobuy',
        name: 'mywantobuy',
        meta: metaAuth,
        component: () => import('@/views/Mywantobuy/index.vue'),
    },
    // 我要卖
    {
        path: '/wanttoSell',
        name: 'wanttoSell',
        meta: metaAuth,
        component: () => import('@/views/WanttoSell/index.vue'),
    },
    // 选择区服
    {
        name: 'wanttoSellGameServer',
        path: '/wanttoSell/gameServer',
        meta: metaAuth,
        component: () => import('@/views/WanttoSell/GameServer/index.vue')
    },
    // 选择角色
    {
        name: 'wanttoSellselectRole',
        path: '/wanttoSell/selectRole',
        meta: metaAuth,
        component: () => import('@/views/WanttoSell/selectRole/index.vue')
    },
    // 出售
    {
        name: 'sell',
        path: '/sell',
        meta: metaAuth,
        component: () => import('@/views/WanttoSell/sell/index.vue')
    },
    // 意见反馈
    {
        path: '/Feedback',
        name: 'Feedback',
        meta: metaAuth,
        component: () => import('@/views/Feedback/index.vue'),
    },
    // 交易行规则
    {
        path: '/regular',
        name: 'regular',
        meta: metaAuth,
        component: () => import('@/views/My/regular/index.vue'),
    },
    // 订单确定
    {
        path: '/confirmOrder',
        name: 'confirmOrder',
        meta: metaAuth,
        component: () => import('@/views/Order/confirmOrder.vue'),
    },
    // 盒币充值
    {
        path: '/boxCoinPay',
        name: 'boxCoinPay',
        meta: metaAuth,
        component: () => import('@/views/BoxCoinPay/index.vue'),
    },
    {
        path: '/',
        name: '/',
        readonly: '/login',
        component: () => import(/* webpackChunkName: "login" */ '@/views/Login/index.vue'),
        children: [
            {
                name: 'login',
                path: '/login',
                meta: metaAuth,
                component: () => import('@/views/Login/login.vue')
            },
            {
                name: 'amend',
                path: '/amend',
                meta: metaAuth,
                component: () => import('@/views/Login/amend.vue')
            },
            {
                name: 'code',
                path: '/code',
                meta: metaAuth,
                component: () => import('@/views/Login/code.vue')
            },
            {
                name: 'setPassWord',
                path: '/setPassWord',
                meta: metaAuth,
                component: () => import('@/views/Login/setPassWord.vue')
            },
            {
                name: 'notPassWord',
                path: '/notPassWord',
                meta: metaAuth,
                component: () => import('@/views/Login/notPassWord.vue')
            },
            {
                name: 'bindPhone',
                path: '/bindPhone',
                meta: metaAuth,
                component: () => import('@/views/Login/bindPhone.vue')
            },
        ]
    },
    {
        path: '/logout',
        name: 'logout',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/Logout.vue'),
    },
]
